export {
  getTours,
  getTour,
  addTour,
  clearNewTour,
  updateTour,
  deleteTour,
  clearTour,
} from './tours';

export { getUsers, userRegister, loginUser, auth } from './users';



// WEBPACK FOOTER //
// ./src/redux/actions/index.js